import React from 'react';
import Relay from 'react-relay';

import Button from 'react-mdl/lib/Button';
import IconButton from 'react-mdl/lib/IconButton';
import Menu, { MenuItem } from 'react-mdl/lib/Menu';
import Textfield from 'react-mdl/lib/Textfield';
import { Dialog, DialogActions, DialogTitle, DialogContent } from 'react-mdl/lib/Dialog';

class MailingListMemberRow extends React.Component {
    componentWillMount() {
        this.setState({
            isEditing: false,
            deleteDialog: false,
        })
    }

    renderStatic() {
        let member = this.props.member;
        let menuBtnId = `member-${member.address}-menu-btn`;

        return (
            <tr>
                <td className="mdl-data-table__cell--non-numeric">{member.name}</td>
                <td className="mdl-data-table__cell--non-numeric">{member.address}</td>
                <td className="mdl-data-table__cell--non-numeric">
                    {member.vars.map(kv => {
                        return (
                            <div><b>{kv.key}</b>: {kv.value}</div>
                        );
                    })}
                </td>
                <td className="mdl-data-table__cell--non-numeric">
                    <IconButton name="more_vert" id={menuBtnId} />
                    <Menu target={menuBtnId} align="right" ripple>
                        <MenuItem onClick={() => this.setState({isEditing: true})}>Edit</MenuItem>
                        <MenuItem onClick={() => this.setState({deleteDialog: true})}>Delete</MenuItem>
                    </Menu>

                    <Dialog open={this.state.deleteDialog} onCancel={() => this.setState({deleteDialog: false})} style={{width: '400px'}}>
                        <DialogTitle>Delete a Member</DialogTitle>
                        <DialogContent>
                            <p>Are you sure you want to delete mailing list member "{member.name || <i>no name</i>} {member.address}"?</p>
                        </DialogContent>
                        <DialogActions>
                            <Button type='button' onClick={() => this.setState({deleteDialog: false})}>Cancel</Button>
                            <Button type='button'>Delete</Button>
                        </DialogActions>
                    </Dialog>
                </td>
            </tr>
        );
    }

    renderEditing() {
        let changes = this.props.member || {};

        return (
            <tr>
                <td className="mdl-data-table__cell--non-numeric">{changes.name}</td>
                <td className="mdl-data-table__cell--non-numeric">{changes.address}</td>
                <td className="mdl-data-table__cell--non-numeric">
                    {changes.vars.map(kv => {
                        return (
                            <div><b>{kv.key}</b>: {kv.value}</div>
                        );
                    })}
                </td>
                <td className="mdl-data-table__cell--non-numeric">
                    <IconButton name="save" onClick={() => this.setState({isEditing: false})}/>
                </td>
            </tr>
        );
    }

    render() {
        if (this.isEditing || !this.props.member) {
            return this.renderEditing()
        } else {
            return this.renderStatic()
        }
    }
}

export default Relay.createContainer(MailingListMemberRow, {
    fragments: {
        member: () => Relay.QL`
            fragment on MailingListMember {
                name
                address
                vars {
                    key
                    value
                }
            }
        `,
    }
});


/** WEBPACK FOOTER **
 ** ./src/Routes/MailingListDetails/MailingListMembers/MailingListMemberRow/MailingListMemberRow.js
 **/